.optionsWrapper {
  padding: 0 20px;
}

.optionsTitle {
  margin-bottom: 24px;
  color: #231e19;
  text-align: center;
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: -0.4px;
}

.options {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
}

.option {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 90px;
  padding: 5px 16px 5px 56px;
  border-radius: 24px;
  background: rgba(243, 237, 223, 0.5);
  box-sizing: border-box;
  cursor: pointer;
  outline: none;
}

.optionRedLabel {
  border-radius: 8px 24px 24px 24px;
}

.optionMostPopular {
  padding-top: 10px;
}

.optionSelected {
  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 24px;
    box-shadow: var(--ed-focus-ring, 0 0 0 3px #c85bff);
  }

  .radio {
    background: url(../img/radio.png) no-repeat center / contain;
    border: none;

    :global(.k9GreenTheme) & {
      background-image: url(../img/radioGreen.svg);
    }
  }

  .dollar,
  .firstPart {
    font-weight: 900;
    color: transparent;
    background: linear-gradient(180deg, #fff 0%, var(--ed-brand, #ba61fe) 40%, var(--ed-brand, #ba61fe) 100%);
    -webkit-background-clip: text;
    background-clip: text;
  }

  .priceDayText {
    color: #7A7670;
  }
}

.optionSelected.optionRedLabel {
  &::after {
    border-radius: 8px 24px 24px 24px;
  }
}

.radio {
  position: absolute;
  top: 50%;
  left: 16px;
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  border: 2px solid var(--ed-border, #ded9ce);
  border: 2px solid var(--ed-border, color(display-p3 0.868 0.85 0.8103));
  border-radius: 39px;
  transform: translateY(-50%);
}

.priceWrapper {
  flex: 1 1 auto;
  min-width: 0;
  padding-right: 8px;
}

.priceTitle {
  margin-bottom: 4px;
  color: #231e19;
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
  font-size: 17px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0.068px;
  text-transform: none;

  @media (max-width: 375px) {
    @at-root html[lang='ru'] & {
      font-size: 14px;
    }

    @at-root html[lang='fr'] & {
      font-size: 15px;
    }

    @at-root html[lang='es'] & {
      font-size: 15px;
    }

    @at-root html[lang='pt'] & {
      font-size: 14px;
      line-height: 17px;
    }

    @at-root html[lang='it'] & {
      font-size: 14px;
    }

    @at-root html[lang='pl'] & {
      font-size: 15px;
    }

    @at-root html[lang='uk'] & {
      font-size: 15px;
    }
  }

  @media (max-width: 360px) {
    @at-root html[lang='fr'] & {
      font-size: 13px;
      line-height: 16px;
    }
  }
}

.price {
  color: #231e19;
  font-size: 12px;
  font-weight: 510;
  line-height: 16px;
  letter-spacing: 0.036px;
}

.priceMeta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.lineRed {
  color: #7b766f;
  font-weight: 400;
  letter-spacing: -0.036px;
  text-decoration: line-through;
  text-decoration-color: #7b766f;
}

.optionDiscountBadge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 14px;
  padding: 0 6px;
  border-radius: 24px;
  background: #e44a08;
  box-shadow: inset 1px -3px 16px 0 rgba(255, 255, 255, 0.6);
  color: #fffbf2;
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
  font-size: 8px;
  font-weight: 800;
  line-height: 14px;
  letter-spacing: 0.32px;
  text-transform: uppercase;
  white-space: nowrap;
}

.priceDay {
  display: flex;
  width: 107px;
  flex-shrink: 0;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
}

.priceDayWrapper {
  display: flex;
  width: 100%;
  margin-top: 4px;
  align-items: flex-start;
  justify-content: flex-end;
}

.dollar {
  position: relative;
  top: 0;
  left: 0;
  display: inline-flex;
  color: #231e19;
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
  font-size: 18px;
  font-weight: 800;
  line-height: 25px;
  letter-spacing: -0.4px;
}

.firstPart {
  margin: 0;
  color: #231e19;
  text-align: right;
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
  font-size: 40px;
  font-weight: 700;
  line-height: 41px;
  letter-spacing: -0.4px;
}

.priceDayText {
  position: relative;
  top: -3px;
  color: #7A7670;
  text-align: right;
  font-size: 11px;
  font-weight: 400;
  line-height: 13px;
  letter-spacing: -0.3px;
}

.bestOffer {
  position: absolute;
  top: 0;
  left: 53.5px;
  transform: translateY(-50%);
  padding: 4px 12px;
  border-radius: 24px;
  background: #ff8e00;
  box-shadow: 1px -3px 16px 0 rgba(255, 255, 255, 0.6) inset;
  z-index: 1;
  color: #fffbf1;
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
  font-size: 10px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: -0.5px;
  text-transform: uppercase;

  @at-root html[lang='ru'] & {
    font-size: 9px;
    padding: 2px 8px;
  }

  @media (max-width: 375px) {
    @at-root html[lang='fr'] & {
      font-size: 9px;
      padding: 2px 8px;
    }

    @at-root html[lang='es'] & {
      font-size: 9px;
      padding: 2px 8px;
    }

    @at-root html[lang='pt'] & {
      font-size: 9px;
      padding: 2px 8px;
    }
  }
}

.labelDiscount {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 4px;
  border-radius: 8px 0;
  background: #f83800;
  color: #fff;
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
  font-size: 10px;
  font-weight: 800;
  line-height: 14px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.tariffV5 {
  .option {
    background: #f3eddf;
  }
}

@media (max-width: 360px) {
  .option {
    padding-right: 12px;
    padding-left: 52px;
  }

  .firstPart {
    font-size: 36px;
  }
}

:global body.dark {
  :local {
    .optionsTitle,
    .priceTitle,
    .price {
      color: #fffbf2;
    }

    .option {
      background-color: #2a2928;
    }

    .radio {
      border-color: var(--ed-border, #7b766f);
    }

    .priceDayText,
    .lineRed {
      color: #8b8984;
    }

    .tariffV5 {
      .option {
        background: #2a2928;
      }
    }

    .optionSelected {
      .dollar,
      .firstPart {
        background: var(--ed-brand, #ba61fe);
        -webkit-background-clip: text;
        background-clip: none;
      }
    }
  }
}

:global body.dark #secondScreenWrapper {
  :local {
    .option {
      background-color: #181716;
    }
  }
}
